module.exports = __webpack_public_path__ + "static/img/CBDcore.75cfd51e.png";